import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { getProductCardL } from 'product-card/constants/settings/ProductCardL/getProductCardL'
import { getProductCardS } from 'product-card/constants/settings/ProductCardS/getProductCardS'
import type { ProductCardSettings } from 'product-card/context/ProductCardConsumerLayoutContext/ProductCardConsumerLayoutContext'
import { useResponsiveBehavior } from 'responsive/hooks/useResponsiveBehavior/useResponsiveBehavior'

type Props = {
	withSlideshow: boolean
}

export const useInspirationalProductCardSettings = ({
	withSlideshow,
}: Props) => {
	const {
		country: { hasOnlineSale },
	} = useMasterData()

	return useResponsiveBehavior<ProductCardSettings>({
		default: {
			...getProductCardL({ hasOnlineSale }),
			shouldRenderSlider: withSlideshow,
			hasColorPicker: false,
			hasProductTags: false,
			hasProductLabels: false,
			hasDotsIndicator: false,
		},
		lessThanLarge: {
			...getProductCardS({ hasOnlineSale }),
			shouldRenderSlider: withSlideshow,
			shouldRenderFeatured: true,
			featuredOnSmall: true,
			hasColorPicker: false,
			hasProductTags: false,
			hasProductLabels: false,
		},
	})
}
